import { PageModule } from '@abp/ng.components/page';
import {
  CoreModule,
  ListService,
} from '@abp/ng.core';
import { ChangeDetectionStrategy, Component } from '@angular/core';

import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { ProfileInfoComponent } from './profile-info/profile-info.component';

@Component({
    selector: 'app-profile-tab',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './profile-tab.component.html',
    imports: [PageModule, CoreModule, NgbDropdownModule, ProfileInfoComponent],
    providers: [ListService]
})
export class ProfileTabComponent {
  constructor() {}
}
